import { Navigate } from "react-router-dom";
import { loadSession, type SessionUser } from "../lib/auth";

export function Protected({
  roles,
  children,
}: {
  roles: SessionUser["role"][];
  children: React.ReactNode;
}) {
  const s = loadSession();
  if (!s) return <Navigate to="/login" replace />;
  if (!roles.includes(s.user.role)) {
    return <Navigate to={s.user.role === "superadmin" ? "/master" : "/app"} replace />;
  }
  return <>{children}</>;
}
